import { Component, Vue } from 'vue-property-decorator'
import { RouterModule } from '@/store/modules/router'
import { SubMenuRightModule } from '@/store/modules/submenu-right'
import { NewReviewModule } from '@/store/modules/newReview'
import { MessageModule } from '@/store/modules/message'
import { getRouters1, getRouters2 } from '@/api/common'

@Component({
})
export default class SubMenu extends Vue {
    routers1 = []
    badgeShow = false // 未读消息数量
    showNav = false
    show = false  //点击菜单展开收起
    activeID = null
    loading = false
    routersName = ''
    routeArr = {}
    sortIndex = []

    // ------ 计算属性 ------
    get path1() {
        return RouterModule.path
    }
    get routerName() {
        return RouterModule.name
    }
    get routerNameActiveId() {
        return RouterModule.activeId
    }
    get subMenuList() {
        return RouterModule.pathChildrens
    }
    get activePath() {
        return RouterModule.pathChildrenActive
    }
    get noSettingCheckedNumber() {
        return SubMenuRightModule.noSetting.checkedNumber
    }
    get messageCheckedNumber() {
        return SubMenuRightModule.messageApproval.checkNumber
    }
    get marketCluesCheckedNumber() {
        return SubMenuRightModule.marketClues.checkedNumber
    }

    get messageRemindBadge() {
        return MessageModule.remindBadge
    }
    get messageReviewNum() {
        return MessageModule.reviewNum
    }
    get messageNoticeNum() {
        return MessageModule.noticeNum
    }
    get messageReviewUserNum() {
        return MessageModule.reviewUserNum
    }

    get msgList() {
        const arr = MessageModule.msgList

        for (const key in arr) {
            if (arr[key].length > 0) {
                this.sortIndex.push(key)
            } else {
                const index = this.sortIndex.indexOf(key)
                if (index !== -1) {
                    this.sortIndex.splice(index, 1)
                }
            }
        }
        this.sortIndex = this.newArrFn(this.sortIndex)
        return MessageModule.msgList
    }

    get messageBadge() {
        return MessageModule.messageBadge
    }
    created() {
        this.initHeadMenu()
        // this.routersName = this.routerName

        this.$store.commit('DELETE_MESG_ITEM', 'remind')
    }

    newArrFn(arr) {
        const newArr = []
        for (let i = 0; i < arr.length; i++) {
            newArr.indexOf(arr[i]) === -1 ? newArr.push(arr[i]) : newArr
        }

        return newArr
    }

    // 初始化菜单
    async initHeadMenu() {
        const data: any = await getRouters1()
        this.routers1 = data.menuList
        RouterModule.SET_ROUTERS1_LIST(data.menuList)
        // 恢复之前保存的一级路由状态
        RouterModule.initRouter1()
        // 使用恢复后的activeId获取二级菜单数据
        let data1: any = await getRouters2({ id: this.routerNameActiveId })
        const nav = this.routers1.find(item=>item.id === this.routerNameActiveId)
        this.activeID = this.routerNameActiveId
        if (nav) {
            this.$set(nav, 'menuList' , data1.menuList)
            this.$set(nav, 'show' , true)
        }
    }
    // 点击一级路由的时候
    async clickRouters(item: { uri: string; id: number; name: string; menuList: any, show: boolean }) {
        this.loading = true
        if(this.activeID != item.id) {
            this.$set(item, 'show', true)
        } else {
            this.$set(item, 'show', !item.show)
        }
        this.activeID = item.id
        if(item.menuList && item.menuList.length > 0) {
            this.loading = false
            return
        }
        const data: any = await getRouters2({ id: item.id })
        this.$set(item, 'menuList' , data.menuList)
        if(data.menuList.length < 1) {
            RouterModule.setRouter1(item)
            RouterModule.SET_PATHCHILDRENS(data.menuList)
            this.$router.push(item.uri)
        }
        this.loading = false
    }
    closeShowNav() {
        this.showNav = false
        this.initHeadMenu()
    }
       // 点击一级路由的时候
    async clickRouters1(item, item1) {
        RouterModule.setRouter1(item)
        const data: any = await getRouters2({ id: item.id })
        this.$set(item, 'menuList' , data.menuList)
        RouterModule.SET_PATHCHILDRENS(data.menuList)
        let path = item.uri
        path += '/' + item1.uri
        this.$router.push(path)
    }
    // ------ 方法 ------
    async clickRouterItem(item: { name: string; id: number; uri: string }) {
        this.$router.push(this.path1 + '/' + item.uri)
        RouterModule.setRouter2(item)
    }

    //- dataShare 数据共享转移
    dataShareClick() {
        SubMenuRightModule.dataShare.dialogDataShow = true
        SubMenuRightModule.dataShare.addDialog = true
    }
    // new-review   新建审批流
    newReview() {
        NewReviewModule.setStepsAvtive(0)
        window.open(window.location.origin + '/newReview')
    }

    // message-approval  消息-权限
    newNotice() {
        SubMenuRightModule.messageNotice.dialogShow = true
    }
    batchApproval() {
        SubMenuRightModule.batchMessageApproval()
    }
}
